export default __webpack_public_path__ + "static/dummyTwo-c4e12f522fb00e0617fb920a9c86cb34.png";